import React, { FC, useState, useEffect, useCallback, memo } from "../../../../lib/teact/teact";
import ConfirmDialog from "../../../ui/ConfirmDialog";
import InputText from "../../../ui/InputText";

type OwnProps = {
    onSearchConfirm: (searchText: string) => void;
    isOpen: boolean;
    onClose: () => void;
    
}

const DialogSearchMessage: FC<OwnProps> = ({
    onSearchConfirm,
    isOpen,
    onClose
}) => {
    const [state, setState] = useState({
        searchText: '',
    });   //debounce search
    function debounce(func: Function, delay: number) {
        let timer: ReturnType<typeof setTimeout>; // lần goij sau, biến timer này có giá trị, chứ ko phải undefined như bt
        let i: number = 0;
        return function (...args: any[]) {
            clearTimeout(timer);
            //console.log(`i=${i++}`)
            timer = setTimeout(() => func(...args), delay);
        };
    }
    const debouncedSetFilter = useCallback(debounce((value: string) => {
        // Thực hiện các tác vụ tìm kiếm hoặc xử lý dữ liệu với giá trị value
        console.log(`debouncedSetFilter: ${value}`);
        onSearchConfirm(value);
    }, 500), []);

    const handleSearchQuery = (query: string) => {
        if (query.length<2) {
            return;
        }
        debouncedSetFilter(query)
    }

    return (
        <ConfirmDialog isOpen={isOpen} onClose={onClose} title="Tìm kiếm tin nhắn"
            isOnlyConfirm 
            confirmHandler={() => {
                onClose();
            }
            }
            confirmLabel="Đóng"
        >
            {/* <label>Tìm kiếm</label> */}
            <InputText value={state.searchText} onChange={(e) => {
                setState(prev => ({ ...prev, searchText: e.target.value }))
                handleSearchQuery(e.target.value)

            }}></InputText>
        </ConfirmDialog>
    )
}

export default memo(DialogSearchMessage);